import { Component, Input, OnInit, EventEmitter, HostListener } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { GridApi } from 'ag-grid-community';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { GrantsSummaryService } from 'src/app/services/grants/grants-summary.service';
import { stateOptionsConstant, titleOptionsConstant, countryOptionsConstant, serviceConstants, chooseOptionsConstant } from 'src/app/constants/service.constants';
import { MessageBoxComponent } from 'src/app/common/message-box/message-box.component';
import { AppFunctionsService } from 'src/app/services/app-functions.service';
import { DateObject, Document_Upload, Document_Upload_File, IST_SITE_EVALUATION, REGCONFIG_CONTROL, dropdownsource } from 'src/app/models/common';
import { Subject } from 'rxjs';
import { GrantsRegistrationsComplianceComponent } from '../grants-registrations-compliance/grants-registrations-compliance.component';
import { CommonService } from '../../../services/common.service';
import * as $ from 'jquery';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UserService } from 'src/app/services/user.service';
import { DatePipe } from '@angular/common';
@Component({
  selector: 'app-grants-registrations-view-modal',
  templateUrl: './grants-registrations-view-modal.component.html',
  styleUrls: ['./grants-registrations-view-modal.component.scss']
})
export class GrantsRegistrationsViewModalComponent implements OnInit {
  //formFields;
  titleOptions = titleOptionsConstant;
  uploadedFiles = [];
  stateOptions = stateOptionsConstant;
  countryOptions = countryOptionsConstant;
  @Input() public Content: any;
  // File upload
  formData: FormData;
  files: any[];
  uploadInput: EventEmitter<any>;
  humanizeBytes: Function;
  dragOver: boolean;
  document_attach_list: Document_Upload_File[] = [];

  orgTypeList: any[];
  taxStatusList: any[];
  prefixList: any[];
  RegistrationForm = new UntypedFormGroup({});
  content: any;
  orgCode: string;
  userType: string;
  regcontrlData : any;
  heading: string;
  action: Subject<any> = new Subject();
  formFields;
  chooseoptions = chooseOptionsConstant;
  generalInformationForm = new UntypedFormGroup({});
  recordstatus: string = "New";   
  public controlsList: REGCONFIG_CONTROL[] = [];
  advanceSearch;
  selectedRow;
  tempdropsource: dropdownsource;
  sourceitems: dropdownsource[] = [];
  screenid: string;
  selectColumns: number = 4;
  screencode: string;
  ScreenContextCode: string = "";
  errormsg: string = "";  
  dynomessage: string = ""; 
  validationMessage: string = "";
  myDate = new Date();
  yesterday = new Date(this.myDate.setDate(new Date().getDate() + 1));
  year: number = this.myDate.getFullYear() + 25;
  timeout: any;
  IsFormToched: boolean = false;
  orgId: string;
  IsBlocked: boolean = false;
  tooltipValue: any;
  constructor(
    private route: ActivatedRoute,
    private summaryService: GrantsSummaryService,
    public modalRef: NgbActiveModal,
    private appFunctions: AppFunctionsService,
    private modalServiceas: NgbModal,
    private modalService: NgbModal,
    public commonService: CommonService,
    private userService: UserService,
    public datepipe: DatePipe,
  ) {
    this.files = [];
    this.uploadInput = new EventEmitter<any>();
  }
  permission :any;

  ngOnInit() {
    

    const reg = '(https?://)?([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*/?';
    // this.RegistrationForm = new UntypedFormGroup({
    //   ID: new UntypedFormControl(''),
    //   ORG_NAME: new UntypedFormControl('', [Validators.required]),
    //   ORG_TYPE: new UntypedFormControl('', [Validators.required]),
    //   WEB_SITE: new UntypedFormControl('', [Validators.required, Validators.pattern(reg)]),
    //   ADDRESS: new UntypedFormControl('', [Validators.required]),
    //   TAX_ID: new UntypedFormControl('', [Validators.required]),
    //   TAX_STATUS: new UntypedFormControl('', [Validators.required]),
    //   IS_AFFILIATED: new UntypedFormControl(false),
    //   AFFILIATED_DESC: new UntypedFormControl(''),
    //   IS_ACCREDIATED: new UntypedFormControl(false),
    //   ACCREDIATED_WITH: new UntypedFormControl(''),

    //   PREFIX: new UntypedFormControl('', [Validators.required]),
    //   FIRST_NAME: new UntypedFormControl('', [Validators.required]),
    //   MIDDLE_NAME: new UntypedFormControl(''),
    //   LAST_NAME: new UntypedFormControl('', [Validators.required]),
    //   EMAIL: new UntypedFormControl('', [Validators.required, Validators.email]),
    //   PERSONAL_ADDRESS: new UntypedFormControl('', [Validators.required]),
    //   RECORD_STATE: new UntypedFormControl(true),
    // });

    this.orgCode = this.Content.content.ORGCODE;
    this.orgId = this.Content.content.ORGID;
   // this.GetMasterData();
    if (this.Content.USERTYPE !== undefined)
      this.userType = this.Content.content.USERTYPE;
    else
      this.userType = "G";
      if(this.Content.heading === 'View' || this.Content.heading === 'Edit')
      {
        this.getScreensControlslistEdit();
        this.permission = 'view';
      }
      else
      {
        this.getScreensControlslist();
        this.permission = 'new';
      }
     
    //if (this.Content.content !== null && this.Content.content !== undefined && this.Content.content.id !== undefined && this.Content.content.id !== null)
     // this.getRegistedDetails();
  }
  @HostListener('input', ['$event'])
  onInputChange(event: any) {
    this.IsFormToched = true;
  }
  // GetMasterData() {
  //   this.orgTypeList = [];
  //   this.taxStatusList = [];
  //   this.prefixList = [];
  //   if(this.orgCode == undefined || this.orgCode == null){
  //     this.orgCode = this.userService.getOrgCode();
  //   }
    // var regId="-1";
    
    // if (this.Content.content !== null && this.Content.content !== undefined && this.Content.content.id !== undefined && this.Content.content.id !== null)
    // {
    //   regId=this.Content.content.id;
    // }
    // this.summaryService.GetMasterScreenData("api/appuser/getmasterdata/" + this.orgCode+"/"+regId).subscribe(summary => {
    //   this.orgTypeList = summary["MasterData1"];
    //   this.orgTypeList = [{ label: "Select", value: null, checked: true }].concat(this.orgTypeList);
    //   this.taxStatusList = summary["MasterData2"];
    //   this.taxStatusList = [{ label: "Select", value: null, checked: true }].concat(this.taxStatusList);
    //   this.prefixList = summary["MasterData3"];
    //   this.prefixList = [{ label: "Select", value: null, checked: true }].concat(this.prefixList);
    // });
  //}
  // getRegistedDetails() {

  //   this.summaryService.getScreenDataForEdit("api/gm/getregistration/" + this.Content.content.id).subscribe(result => {
  //     this.RegistrationForm.patchValue(result);
  //     this.RegistrationForm.controls['RECORD_STATE'].setValue(this.RegistrationForm.controls['RECORD_STATE'].value == 1 ? false : true);
  //     this.RegistrationForm.disable();
  //     this.RegistrationForm.controls['RECORD_STATE'].enable();
  //   this.document_attach_list=result["Files"];
  //   });


  // }

  // setRegistration() {
 
  //   const reg = '(https?://)?([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*/?';
  //   this.RegistrationForm = new UntypedFormGroup({
  //     ID: new UntypedFormControl(''),
  //     NAME: new UntypedFormControl('', [Validators.required]),
  //     TYPE: new UntypedFormControl('', [Validators.required]),
  //     WEB_SITE: new UntypedFormControl('', [Validators.required, Validators.pattern(reg)]),
  //     ADDRESS: new UntypedFormControl('', [Validators.required]),
  //     TAX_ID: new UntypedFormControl('', [Validators.required]),
  //     TAX_STATUS: new UntypedFormControl('', [Validators.required]),
  //     IS_AFFILIATED: new UntypedFormControl(''),
  //     AFFILIATED_DESC: new UntypedFormControl(''),
  //     IS_ACCREDIATED: new UntypedFormControl(''),
  //     ACCREDIATED_WITH: new UntypedFormControl(''),

  //     PREFIX: new UntypedFormControl('', [Validators.required]),
  //     FIRST_NAME: new UntypedFormControl('', [Validators.required]),
  //     MIDDLE_NAME: new UntypedFormControl(''),
  //     LAST_NAME: new UntypedFormControl('', [Validators.required]),
  //     EMAIL: new UntypedFormControl('', [Validators.required, Validators.email]),
  //     PERSONAL_ADDRESS: new UntypedFormControl('', [Validators.required]),
  //     RECORD_STATE: new UntypedFormControl(true),

  //   });
  // }

  // Registration() {
  //   if (this.validateControls()) {
  //     let formData = this.RegistrationForm.value;
  //     formData["IS_AFFILIATED"] = (formData["IS_AFFILIATED"] === undefined || formData["IS_AFFILIATED"] === null) ? false : formData["IS_AFFILIATED"];
  //     formData["IS_ACCREDIATED"] = (formData["IS_ACCREDIATED"] === undefined || formData["IS_ACCREDIATED"] === null) ? false : formData["IS_ACCREDIATED"];

  //     formData["RECORD_STATE"] = 0;
  //     formData["CREATED_DATE"] = new Date();
  //     formData["LAST_UPDATED_DATE"] = new Date();
  //     formData["ORGCODE"] = this.orgCode;
  //     formData["USERTYPE"] = this.userType;

  //     let formData1 = new FormData();
  //     if (this.document_attach_list != null && this.document_attach_list.length > 0) {
  //       for (let i = 0; i < this.document_attach_list.length; i++) {
  //         this.document_attach_list[i].TRANSACTION_ID = ("" + (i + 1));
  //         formData1.append(("" + (i + 1)), this.document_attach_list[i].File);
  //       }
  //     }

  //     formData["FILES"] = this.document_attach_list;
  //     formData1.append("ScreenData", JSON.stringify(formData));

  //     if (this.Content.content.RegistrationType == "Grant") {
  //       this.summaryService.FilesInsert("api/appuser/InsertGrantsRegistration", formData1).subscribe(result => {
  //         if (result.Status === 0 && result.ErrorCode != "GR01") {
  //           this.commonService.SuccessBanner("Grants Registration successful. An email with temporary password is sent to the registered email id. Please use the temporary password to login");
  //           this.modalRef.close();
  //         } else if (result.ErrorCode === "GR01") {
  //           this.commonService.SuccessBanner("Grants Registration successful, please use your existing login details to access the Grants program");
  //           this.modalRef.close();
  //         }
  //         else {
  //           this.commonService.ValidationBanner(result.Message);
  //         }
  //       });
  //     }
  //     else {
  //       this.summaryService.Insert("api/appuser/insertistregistration", formData).subscribe((result) => {
  //         if (result.Status === 0) {
  //           this.modalRef.close();
  //         }
  //         else {
  //           //this.modalService.show(MessageBoxComponent, { data: { heading: 'Insert', content: { heading: '', description: result.Message } } });
  //         }
  //       });
  //     }

  //   }
  // }

  // DeleteUpload(file): void {
   
  //   if (file.Status == "Add") {
  //     let code = file.ID;
  //     this.document_attach_list = this.document_attach_list.filter(function (sec) {
  //       return sec.ID != code;
  //     }, code);
  //   }
  //   else {
  //     file.Status = "Delete";
  //   }
  // }

  // ViewFile(fileID, fileName) {
  //   this.commonService.previewFile(fileID, fileName, "med");
  // }

  // DownloadFile(ID) {
  //   var fileID = ID;
  //   let Url = serviceConstants.apiURL + "api/ISTFileAttachments/Downloadfile?FileID=" + fileID;
  //   window.open(Url);
  // }

  // uploadchange(event): void {
   
  //   if (this.document_attach_list == undefined || this.document_attach_list == null) {
  //     this.document_attach_list = [];
  //   }

  //   let hasUnFormat = false;
  //   let wrongFile = false;
  //   for (let i = 0; i < event.target.files.length; i++) {
  //     let uploadFile = new Document_Upload_File();
  //     var file = event.target.files[i].name;
  //     var ext = file.match(/\.([^\.]+)$/)[1];
  //     var filesize = event.target.files[i].size;

  //     if (file != "Form.W-8BEN.pdf" && file != "Form.W-9.pdf") {
  //       wrongFile = true;
  //     } else {
  //       if (file != null && ((filesize > 10485760) || (ext != 'pdf'))) {
  //         hasUnFormat = true;
  //       }
  //       else {
  //         let hasValue;
  //         let value;
  //         uploadFile.ID = this.commonService.getUniqueId();
  //         uploadFile.DOCUMENT_NAME = event.target.files[i].name;
  //         uploadFile.File = event.target.files[i];
  //         uploadFile.Status = "Add";
  //         if (this.uploadedFiles?.length > 0) {
  //           hasValue = this.uploadedFiles?.filter(x => x.DOCUMENT_NAME.toLowerCase() == uploadFile.DOCUMENT_NAME.toLowerCase());
  //         }

  //         if (this.document_attach_list?.length > 0) {
  //           value = this.document_attach_list.filter(x => x.DOCUMENT_NAME.toLowerCase() == uploadFile.DOCUMENT_NAME.toLowerCase());

  //         }

  //         if (hasValue?.length > 0 || value?.length > 0) {
  //           this.commonService.ValidationBanner("File already exists with " + uploadFile.DOCUMENT_NAME + " Please update the unique file name");
  //         } else {
  //           this.document_attach_list.push(uploadFile);
  //         }
  //       }
  //     }
  //   }

  //   if (wrongFile) {
  //     this.commonService.ValidationBanner("Please upload files with same name and format");
  //   }

  //   if (hasUnFormat) {
  //     this.commonService.ValidationBanner("Please upload files with Pdf format only with maximum size of 15MB");
  //   }
  // }

  // showFiles() {
  //   let files = '';
  //   this.uploadedFiles = [];

  //   for (let i = 0; i < this.files.length; i++) {
  //     files += this.files[i].name;
  //     if (!(this.files.length - 1 === i)) {
  //       files += ',';
  //     }

  //   }

  //   for (let i = 0; i < this.files.length; i++) {
  //     let newAttachment = this.files[i].name;
  //     this.uploadedFiles.push(newAttachment);
  //   }

  //   return files;
  // }

  // startUpload(): void {
  //   const event: any = {
  //     type: 'uploadAll',
  //     url: 'your-path-to-backend-endpoint',
  //     method: 'POST',
  //     data: { foo: 'bar' },
  //   };
  //   this.files = [];
  //   this.uploadInput.emit(event);
  // }

  // onUploadOutput(output: any | any): void {

  //   if (output.type === 'allAddedToQueue') {
  //   } else if (output.type === 'addedToQueue') {
  //     this.files.push(output.file); // add file to array when added
  //   } else if (output.type === 'uploading') {
  //     // update current data in files array for uploading file
  //     const index = this.files.findIndex(file => file.id === output.file.id);
  //     this.files[index] = output.file;
  //   } else if (output.type === 'removed') {
  //     // remove file from array when removed
  //     this.files = this.files.filter((file: any) => file !== output.file);
  //   } else if (output.type === 'dragOver') {
  //     this.dragOver = true;
  //   } else if (output.type === 'dragOut') {
  //   } else if (output.type === 'drop') {
  //     this.dragOver = false;
  //   }
  //   this.showFiles();
  // }

  // openComplianceModal() {
  //   const modalRef = this.modalServiceas.open(GrantsRegistrationsComplianceComponent, {
  //     backdrop: false,
  //     keyboard: false,
  //     windowClass: 'modal-vlg modal-full-height modal-right',
  //     animation: true
  //   });
  //   modalRef.componentInstance.Content = {
  //     heading: 'Add',
  //     content: null
  //   }
  // }

  // validateControls(): boolean {
  //   let isValid = true;
  //   let message = "";
  //   const formData = this.RegistrationForm.value;

  //   if (formData.ORG_NAME === null || formData.ORG_NAME === "" || formData.ORG_NAME === undefined) {
  //     $("#ORG_NAME").addClass("ng-touched ng-invalid validate-error");
  //     $("#ORG_NAME").removeClass("ng-untouched ng-valid");
  //     message += "Please enter Organization Name (must match W-9/8)<br/>";
  //     isValid = false;
  //   } else {
  //     $("#ORG_NAME").addClass("ng-untouched ng-valid");
  //     $("#ORG_NAME").removeClass("ng-touched ng-invalid validate-error");
  //   }

  //   if (formData.ORG_TYPE === null || formData.ORG_TYPE === "" || formData.ORG_TYPE === undefined) {
  //     $("#ORG_TYPE").addClass("ng-touched ng-invalid validate-error");
  //     $("#ORG_TYPE").removeClass("ng-untouched ng-valid");
  //     message += "Please select Organization Type<br/>";
  //     isValid = false;
  //   } else {
  //     $("#ORG_TYPE").addClass("ng-untouched ng-valid");
  //     $("#ORG_TYPE").removeClass("ng-touched ng-invalid validate-error");
  //   }

  //   if (formData.ADDRESS === null || formData.ADDRESS === "" || formData.ADDRESS === undefined) {
  //     $("#ADDRESS").addClass("ng-touched ng-invalid validate-error");
  //     $("#ADDRESS").removeClass("ng-untouched ng-valid");
  //     message += "Please enter Address<br/>";
  //     isValid = false;
  //   } else {
  //     $("#ADDRESS").addClass("ng-untouched ng-valid");
  //     $("#ADDRESS").removeClass("ng-touched ng-invalid validate-error");
  //   }

  //   if (formData.TAX_ID === null || formData.TAX_ID === "" || formData.TAX_ID === undefined) {
  //     $("#TAX_ID").addClass("ng-touched ng-invalid validate-error");
  //     $("#TAX_ID").removeClass("ng-untouched ng-valid");
  //     message += "Please enter Tax ID<br/>";
  //     isValid = false;
  //   } else {
  //     $("#TAX_ID").addClass("ng-untouched ng-valid");
  //     $("#TAX_ID").removeClass("ng-touched ng-invalid validate-error");
  //   }

  //   if (formData.TAX_STATUS === null || formData.TAX_STATUS === "" || formData.TAX_STATUS === undefined) {
  //     $("#TAX_STATUS").addClass("ng-touched ng-invalid validate-error");
  //     $("#TAX_STATUS").removeClass("ng-untouched ng-valid");
  //     message += "Please select Tax Status<br/>";
  //     isValid = false;
  //   } else {
  //     $("#TAX_STATUS").addClass("ng-untouched ng-valid");
  //     $("#TAX_STATUS").removeClass("ng-touched ng-invalid validate-error");
  //   }
  //   if (formData.WEB_SITE === null || formData.WEB_SITE === "") {
  //   }
  //   else {
  //     const siteformat = /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/gi;
  //     if (formData.WEB_SITE.match(siteformat)) {
  //       $("#WEB_SITE").addClass("ng-untouched ng-valid");
  //       $("#WEB_SITE").removeClass("ng-touched ng-invalid validate-error");
  //     }
  //     else {
  //       $("#WEB_SITE").addClass("ng-touched ng-invalid validate-error");
  //       $("#WEB_SITE").removeClass("ng-untouched ng-valid");
  //       message += "Please enter Valid Website<br/>";
  //       isValid = false;
  //     }
  //   }

  //   if (formData.IS_AFFILIATED !== null && formData.IS_AFFILIATED !== "" && formData.IS_AFFILIATED !== undefined
  //     && formData.IS_AFFILIATED !== false
  //   ) {
  //     if (formData.AFFILIATED_DESC === null || formData.AFFILIATED_DESC === "" || formData.AFFILIATED_DESC === undefined) {
  //       $("#AFFILIATED_DESC").addClass("ng-touched ng-invalid validate-error");
  //       $("#AFFILIATED_DESC").removeClass("ng-untouched ng-valid");
  //       message += "Please enter If yes describe <br/>";
  //       isValid = false;
  //     }
  //     else {
  //       $("#AFFILIATED_DESC").addClass("ng-untouched ng-valid");
  //       $("#AFFILIATED_DESC").removeClass("ng-touched ng-invalid validate-error");
  //     }
  //   } else {
  //     $("#AFFILIATED_DESC").addClass("ng-untouched ng-valid");
  //     $("#AFFILIATED_DESC").removeClass("ng-touched ng-invalid validate-error");
  //   }

  //   if (formData.IS_ACCREDIATED !== null && formData.IS_ACCREDIATED !== "" && formData.IS_ACCREDIATED !== undefined && formData.IS_ACCREDIATED !== false) {
  //     if (formData.ACCREDIATED_WITH === null || formData.ACCREDIATED_WITH === "" || formData.ACCREDIATED_WITH === undefined) {
  //       $("#ACCREDIATED_WITH").addClass("ng-touched ng-invalid validate-error");
  //       $("#ACCREDIATED_WITH").removeClass("ng-untouched ng-valid");
  //       message += "Please enter If yes with whom<br/>";
  //       isValid = false;
  //     }
  //     else {
  //       $("#ACCREDIATED_WITH").addClass("ng-untouched ng-valid");
  //       $("#ACCREDIATED_WITH").removeClass("ng-touched ng-invalid validate-error");
  //     }
  //   } else {
  //     $("#ACCREDIATED_WITH").addClass("ng-untouched ng-valid");
  //     $("#ACCREDIATED_WITH").removeClass("ng-touched ng-invalid validate-error");
  //   }

  //   if (formData.PREFIX === null || formData.PREFIX === "" || formData.PREFIX === undefined) {
  //     $("#PREFIX").addClass("ng-touched ng-invalid validate-error");
  //     $("#PREFIX").removeClass("ng-untouched ng-valid");
  //     message += "Please select Prefix<br/>";
  //     isValid = false;
  //   } else {
  //     $("#PREFIX").addClass("ng-untouched ng-valid");
  //     $("#PREFIX").removeClass("ng-touched ng-invalid validate-error");
  //   }

  //   if (formData.FIRST_NAME === null || formData.FIRST_NAME === "" || formData.FIRST_NAME === undefined) {
  //     $("#FIRST_NAME").addClass("ng-touched ng-invalid validate-error");
  //     $("#FIRST_NAME").removeClass("ng-untouched ng-valid");
  //     message += "Please enter First Name<br/>";
  //     isValid = false;
  //   } else {
  //     $("#FIRST_NAME").addClass("ng-untouched ng-valid");
  //     $("#FIRST_NAME").removeClass("ng-touched ng-invalid validate-error");
  //   }

  //   if (formData.LAST_NAME === null || formData.LAST_NAME === "" || formData.LAST_NAME === undefined) {
  //     $("#LAST_NAME").addClass("ng-touched ng-invalid validate-error");
  //     $("#LAST_NAME").removeClass("ng-untouched ng-valid");
  //     message += "Please enter Last Name<br/>";
  //     isValid = false;
  //   } else {
  //     $("#LAST_NAME").addClass("ng-untouched ng-valid");
  //     $("#LAST_NAME").removeClass("ng-touched ng-invalid validate-error");
  //   }

  //   if (formData.EMAIL === null || formData.EMAIL === "" || formData.EMAIL === undefined) {
  //     $("#EMAIL").addClass("ng-touched ng-invalid validate-error");
  //     $("#EMAIL").removeClass("ng-untouched ng-valid");
  //     message += "Please enter Email ID<br/>";
  //     isValid = false;
  //   } else {
  //     let isemailvalid = this.commonService.validateEmail(formData.EMAIL);
  //     if (isemailvalid) {
  //       $("#EMAIL").addClass("ng-untouched ng-valid");
  //       $("#EMAIL").removeClass("ng-touched ng-invalid validate-error");
  //     }
  //     else {
  //       $("#EMAIL").addClass("ng-touched ng-invalid validate-error");
  //       $("#EMAIL").removeClass("ng-untouched ng-valid");
  //       message += "Please enter valid Email ID<br/>";
  //       isValid = false;
  //     }
  //   }
  //   if (!isValid)
  //     this.commonService.ValidationBanner(message);
  //   return isValid;
  // }

  downloadpdf(type) {
    if(type=="File1")
    {
      let link = document.createElement('a');
      link.setAttribute('type', 'hidden');
      link.href = "/assets/Form.W-8BEN.pdf";
      link.download ="Form.W-8BEN.pdf";
      document.body.appendChild(link);
      link.click();
      link.remove();
    }
    else{
      let link = document.createElement('a');
      link.setAttribute('type', 'hidden');
      link.href = "/assets/Form.W-9.pdf";
      link.download ="Form.W-9.pdf";
      document.body.appendChild(link);
      link.click();
      link.remove();
    }
    
  }

  // BlockUser() {
  //   const formData = this.RegistrationForm.value;
  //   formData.ID = this.Content.content.id;
  //   formData.RECORD_STATE = this.RegistrationForm.controls["RECORD_STATE"].value == true ? 0 : 1;
  //   formData.MODULE = this.Content.content.Module;
  //   this.summaryService.updateUser("api/gm/updateUser", formData).subscribe((result: any) => {
  //     if (result.Status == 0) {
  //       // this.commonService.ErrorBanner("update successful");
  //       this.commonService.SuccessBanner("Registration Details updated successfully");
  //       //  this.action.next("Yes");
  //       this.modalRef.close("Yes");
       
  //     } else {
  //       this.commonService.ValidationBanner(result.Message);
  //     }


  //   });
  // }

  getScreensControlslist() {
    this.heading = "New";
    let ModuleId  = "4"; 
    this.summaryService.GetregistrationProgram('api/appuser/GetregistrationProgram?ModuleId=' +  ModuleId+"&orgId="+this.orgId).subscribe(summary => {
      this.controlsList = summary;      
      if (this.controlsList != null && this.controlsList.length > 0) {
       // this.screenid = this.screencontrols.ID;
        for (var i = 0; i < this.controlsList.length; i++) {
          this.controlsList[i].ControlValue = "";
            this.controlsList[i].SourceItems =  [];
          if (this.controlsList[i].CONTROL == "4" || this.controlsList[i].CONTROL == "6" || this.controlsList[i].CONTROL == "7" || this.controlsList[i].CONTROL == "10") {
            // var optionvalues = this.screencontrols.SCREEN_CONTROL[i].GROUP_VALUES;
            var optionvalues = this.controlsList[i].GROUP_VALUES_LIST;
            
            var options = optionvalues;
            this.sourceitems = [];
            // var options = optionvalues.split(',');
            if (options!=null && options!=undefined && options.length > 0) {            
              for (var iOpt = 0; iOpt < options.length; iOpt++) {
                if (options[iOpt] != null && options[iOpt] != "") {
                  let sourceitems = new dropdownsource();
                  sourceitems.label = options[iOpt]["label"];
                  sourceitems.value = options[iOpt]["value"];                  
                  this.sourceitems.push(sourceitems);
                }
              }
              if (this.controlsList[i].CONTROL == "4") {
                let tempList = [];
                let sourceitems1 = new dropdownsource();
                sourceitems1.label = "Select";
                sourceitems1.value = "";
                tempList.push(sourceitems1);
                this.sourceitems = tempList.concat(this.sourceitems);
              }
              this.controlsList[i].SourceItems = this.sourceitems;
            }
          }
          else if (this.controlsList[i].CONTROL == "5") {
            const now = new Date();
            let formd = "";
            formd = this.datepipe.transform(new Date(), 'dd-MMM-yyyy');
             this.controlsList[i].ControlValue = null;
          }
          else {
            this.controlsList[i].ControlValue = "";
          }
        }          
      }
    });
  }

  // validateControls(): boolean {
  //   var isValiddata = true;
  //   let message = "";
  //   if (this.controlsList != null && this.controlsList.length > 0) {
  //     for (var i = 0; i < this.controlsList.length; i++) {
  //       if (this.controlsList[i].IS_MANDATORY) // 
  //       {
  //         if (this.controlsList[i].CONTROL == '8') {
  //           if (this.controlsList[i].UploadFiles != null && this.controlsList[i].UploadFiles != undefined) {
  //             var filelist = this.controlsList[i].UploadFiles.filter(function (sec) {
  //               return sec.Status == "Add" || sec.Status == "Edit";
  //             });
  //             if (filelist.length == 0) {
  //               isValiddata = false;
  //               //var controlName = "dynmcId" + this.controlsList[i].SERIAL_NO;
  //               //$("#" + controlName).addClass("ng-touched ng-invalid validate-error");
  //               //$("#" + controlName).removeClass("ng-untouched ng-valid");
  //             }
  //             else {
  //               //var controlName = "dynmcId" + this.controlsList[i].SERIAL_NO;
  //               //$("#" + controlName).addClass("ng-untouched ng-valid");
  //               //$("#" + controlName).removeClass("ng-touched ng-invalid validate-error");
  //             }
  //           }
  //           else {
  //             isValiddata = false;
  //             //var controlName = "dynmcId" + this.controlsList[i].SERIAL_NO;
  //             //$("#" + controlName).addClass("ng-touched ng-invalid validate-error");
  //             //$("#" + controlName).removeClass("ng-untouched ng-valid");
  //           }
  //         }
  //         if (this.controlsList[i].CONTROL == '6') // Check box
  //         {
  //           var temp = this.controlsList[i].SourceItems.filter(function (sec) {
  //             return sec.Checked == true;
  //           });
  //           if (temp.length == 0) {
  //             isValiddata = false;
  //             var controlName = "dynmcId" + this.controlsList[i].SERIAL_NO;
  //             $("#" + controlName).addClass("ng-touched ng-invalid validate-error");
  //             $("#" + controlName).removeClass("ng-untouched ng-valid");
  //             this.errormsg += "<li>" + this.controlsList[i].LABEL + "<br/></li>";
  //           }
  //           else {
  //             var controlName = "dynmcId" + this.controlsList[i].SERIAL_NO;
  //             $("#" + controlName).addClass("ng-untouched ng-valid");
  //             $("#" + controlName).removeClass("ng-touched ng-invalid validate-error");
  //           }
  //         }
  //         else {
  //           if (this.controlsList[i].ControlValue == "" || this.controlsList[i].ControlValue == null || this.controlsList[i].ControlValue == undefined) {
  //             isValiddata = false;
  //             var controlName = "dynmcId" + this.controlsList[i].SERIAL_NO;
  //             $("#" + controlName).addClass("ng-touched ng-invalid validate-error");
  //             $("#" + controlName).removeClass("ng-untouched ng-valid");
  //             this.errormsg += "<li>" + this.controlsList[i].LABEL + "<br/></li>";
  //           }
  //           else {
  //             var controlName = "dynmcId" + this.controlsList[i].SERIAL_NO;
  //             $("#" + controlName).addClass("ng-untouched ng-valid");
  //             $("#" + controlName).removeClass("ng-touched ng-invalid validate-error");
  //           }
  //         }

  //       }
  //     }
  //   }
  //   this.errormsg = "<ul>" + this.errormsg + "</ul>"
  //   return isValiddata;
  // }
  public validateControlsMsgs(): string {
    this.validationMessage = "";
    if (this.controlsList != null && this.controlsList.length > 0) {
      for (var i = 0; i < this.controlsList.length; i++) {
        $("#dynmcId" + this.controlsList[i].SERIAL_NO).addClass("ng-untouched ng-valid");
        $("#dynmcId" + this.controlsList[i].SERIAL_NO).removeClass("ng-pristine ng-invalid ng-touched validate-error");

        if (this.controlsList[i].CONTROL == "6") {
          let seletedItem = "";
          for (let c = 0; c < this.controlsList[i].SourceItems.length; c++) {
            if (this.controlsList[i].SourceItems[c].Checked == true) {
              if (seletedItem == "")
                seletedItem = this.controlsList[i].SourceItems[c].value;
              else
                seletedItem = seletedItem + "," + this.controlsList[i].SourceItems[c].value;
            }
          }
          this.controlsList[i].ControlValue = seletedItem;
          if (this.controlsList[i].IS_MANDATORY && (this.controlsList[i].ControlValue == "" || this.controlsList[i].ControlValue == null || this.controlsList[i].ControlValue == undefined)) {
            this.validationMessage += "Please select " + this.controlsList[i].LABEL + "<br/>";
            $("#dynmcId" + this.controlsList[i].SERIAL_NO).addClass("ng-pristine ng-invalid ng-touched validate-error");
            $("#dynmcId" + this.controlsList[i].SERIAL_NO).removeClass("ng-untouched ng-valid");
          }
        }
        else if (this.controlsList[i].CONTROL == "10" && this.controlsList[i].IS_MANDATORY) {
          let SelectedValues = this.controlsList[i].ControlValue;
          // if ((SelectedValues == null || SelectedValues == undefined || SelectedValues == "") && this.controlsList[i].NotimesChanged < 2) {
          //   SelectedValues = this.controlsList[i].SUBFIELDNAME;
          // }
          if (SelectedValues == null || SelectedValues == undefined || SelectedValues == "") {
            this.validationMessage += "Please select " + this.controlsList[i].LABEL + "<br/>";
            $("#dynmcId" + this.controlsList[i].SERIAL_NO).addClass("ng-pristine ng-invalid ng-touched validate-error");
            $("#dynmcId" + this.controlsList[i].SERIAL_NO).removeClass("ng-untouched ng-valid");

          }
        }
        else if ((this.controlsList[i].CONTROL == "1" || this.controlsList[i].CONTROL == "2" || this.controlsList[i].CONTROL == "3" || this.controlsList[i].CONTROL == "11") && this.controlsList[i].CONTROL != "8" && this.controlsList[i].CONTROL != "9" && this.controlsList[i].IS_MANDATORY && (this.controlsList[i].ControlValue == "" || this.controlsList[i].ControlValue == null || this.controlsList[i].ControlValue == undefined)) // 
        {
          var controlName = "dynmcId" + this.controlsList[i].SERIAL_NO;
          this.validationMessage += "Please enter " + this.controlsList[i].LABEL + "<br/>";
          $("#dynmcId" + this.controlsList[i].SERIAL_NO).addClass("ng-pristine ng-invalid ng-touched validate-error");
          $("#dynmcId" + this.controlsList[i].SERIAL_NO).removeClass("ng-untouched ng-valid");
        }
        else if((this.controlsList[i].CONTROL == "1" || this.controlsList[i].CONTROL == "2" || this.controlsList[i].CONTROL == "3" || this.controlsList[i].CONTROL == "11") && this.controlsList[i].CONTROL != "8" && this.controlsList[i].CONTROL != "9" && this.controlsList[i].IS_MANDATORY && (this.controlsList[i].ControlValue != null && this.controlsList[i].ControlValue != undefined)){
          let  tempVal=this.controlsList[i].ControlValue.trim();
          if(tempVal==""){
            var controlName = "dynmcId" + this.controlsList[i].SERIAL_NO;
            this.validationMessage += "Please enter " + this.controlsList[i].LABEL + "<br/>";
            $("#dynmcId" + this.controlsList[i].SERIAL_NO).addClass("ng-pristine ng-invalid ng-touched validate-error");
            $("#dynmcId" + this.controlsList[i].SERIAL_NO).removeClass("ng-untouched ng-valid");
          }
        }
        else if (this.controlsList[i].CONTROL == "4" && this.controlsList[i].IS_MANDATORY && (this.controlsList[i].ControlValue == "" || this.controlsList[i].ControlValue == null || this.controlsList[i].ControlValue == undefined)) // 
        {
          var controlName = "dynmcId" + this.controlsList[i].SERIAL_NO;
          this.validationMessage += "Please select " + this.controlsList[i].LABEL + "<br/>";
          $("#dynmcId" + this.controlsList[i].SERIAL_NO).addClass("ng-pristine ng-invalid ng-touched validate-error");
          $("#dynmcId" + this.controlsList[i].SERIAL_NO).removeClass("ng-untouched ng-valid");
        }
        else if (this.controlsList[i].CONTROL == "5" && this.controlsList[i].IS_MANDATORY && (this.controlsList[i].ControlValue == "" || this.controlsList[i].ControlValue == null || this.controlsList[i].ControlValue == undefined)) // 
        {
          var controlName = "dynmcId" + this.controlsList[i].SERIAL_NO;
          this.validationMessage += "Please select " + this.controlsList[i].LABEL + "<br/>";
          $("#dynmcId" + this.controlsList[i].SERIAL_NO).addClass("ng-pristine ng-invalid ng-touched validate-error");
          $("#dynmcId" + this.controlsList[i].SERIAL_NO).removeClass("ng-untouched ng-valid");
        }
        else if (this.controlsList[i].CONTROL == "7" && this.controlsList[i].IS_MANDATORY && (this.controlsList[i].ControlValue == "" || this.controlsList[i].ControlValue == null || this.controlsList[i].ControlValue == undefined)) // 
        {
          this.validationMessage += "Please select " + this.controlsList[i].LABEL + "<br/>";
          $("#dynmcId" + this.controlsList[i].SERIAL_NO).addClass("ng-pristine ng-invalid ng-touched validate-error");
          $("#dynmcId" + this.controlsList[i].SERIAL_NO).removeClass("ng-untouched ng-valid");
        }
        else if (this.controlsList[i].CONTROL == "8" && this.controlsList[i].IS_MANDATORY) {

          if (this.controlsList[i].UploadFiles == null || this.controlsList[i].UploadFiles == undefined || this.controlsList[i].UploadFiles.length == 0) {
            this.validationMessage += "Please upload " + this.controlsList[i].LABEL + "<br/>";
            $("#dynmcId" + this.controlsList[i].SERIAL_NO).addClass("ng-pristine ng-invalid ng-touched validate-error");
            $("#dynmcId" + this.controlsList[i].SERIAL_NO).removeClass("ng-untouched ng-valid");
          }
          else if (this.controlsList[i].UploadFiles != null && this.controlsList[i].UploadFiles != undefined && this.controlsList[i].UploadFiles.length > 0) {
            let fileexits = this.controlsList[i].UploadFiles.filter((f) => {
              return f.Status != 'Delete'
            })[0];
            if (fileexits == undefined || fileexits == null) {
              this.validationMessage += "Please upload " + this.controlsList[i].LABEL + "<br/>";
              $("#dynmcId" + this.controlsList[i].SERIAL_NO).addClass("ng-pristine ng-invalid ng-touched validate-error");
              $("#dynmcId" + this.controlsList[i].SERIAL_NO).removeClass("ng-untouched ng-valid");
            }
          }

        }
        if ((this.controlsList[i].CONTROL == "1" || this.controlsList[i].CONTROL == "2" || this.controlsList[i].CONTROL == "3" || this.controlsList[i].CONTROL == "11") && this.controlsList[i].IS_MANDATORY && this.controlsList[i].ControlValue != null && this.controlsList[i].ControlValue != undefined)
        {
          this.controlsList[i].ControlValue= this.controlsList[i].ControlValue.trim();
          if (this.controlsList[i].FIELD_CODE == "EMAIL" && this.controlsList[i].ControlValue != null && this.controlsList[i].ControlValue != undefined && this.controlsList[i].ControlValue != "") {
            let isvalid = this.commonService.validateEmail(this.controlsList[i].ControlValue);
            if (!isvalid) {
              this.validationMessage += "Please enter valid " + this.controlsList[i].LABEL + "<br/>";
              $("#dynmcId" + this.controlsList[i].SERIAL_NO).addClass("ng-pristine ng-invalid ng-touched validate-error");
              $("#dynmcId" + this.controlsList[i].SERIAL_NO).removeClass("ng-untouched ng-valid");

            }
          }

          if (this.controlsList[i].FIELD_CODE == "WEBSITE" && this.controlsList[i].ControlValue != null && this.controlsList[i].ControlValue != undefined && this.controlsList[i].ControlValue != "") {
            const website = '(https?://)?([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*/?';
            if (!this.controlsList[i].ControlValue.match(website)) {
              this.validationMessage += "Please enter valid " + this.controlsList[i].LABEL + "<br/>";
              $("#dynmcId" + this.controlsList[i].SERIAL_NO).addClass("ng-pristine ng-invalid ng-touched validate-error");
              $("#dynmcId" + this.controlsList[i].SERIAL_NO).removeClass("ng-untouched ng-valid");
            }
          }
        }
      }
    }
    return this.validationMessage;
  }
  isDateModified: boolean = false;

  Full_Date: DateObject;

  DateSelect(event, question) {
    this.IsFormToched = true;
    this.isDateModified = true;
    this.Full_Date = {
      Day: event.getDate(),
      Month: (event.getMonth() + 1),
      Year: event.getFullYear(),
      Hours: 0,
      Minutes: 0,
      Seconds: 0,
      IsEndDate: false,
      HasValue: true,
      IsDateModified: this.isDateModified
    }
    question.dynamicDateobj = this.Full_Date;
  }


  Registration() {
    this.errormsg = "";
    var errormsg = this.validateControlsMsgs();
    let formData1 = new FormData(); 
    let uploadData  = new FormData();    
    if (errormsg.length == 0) {
      if (this.controlsList != null && this.controlsList.length > 0) {         
        for (var i = 0; i < this.controlsList.length; i++) {          

          if (this.controlsList[i].CONTROL == "6") {
            let seletedItem = "";
            for (let c = 0; c < this.controlsList[i].SourceItems.length; c++) {
              if (this.controlsList[i].SourceItems[c].Checked == true) {
                if (seletedItem == "")
                  seletedItem = this.controlsList[i].SourceItems[c].value;
                else
                  seletedItem = seletedItem + "," + this.controlsList[i].SourceItems[c].value;
              }
            }
            this.controlsList[i].ANSWER = seletedItem;
          }
          else if (this.controlsList[i].CONTROL == "8") {
            if (this.controlsList[i].UploadFiles != null && this.controlsList[i].UploadFiles != undefined) {
              for (let j = 0; j < this.controlsList[i].UploadFiles.length; j++) {
                if (this.controlsList[i].UploadFiles[j].Status == "Add") {
                  uploadData.append(this.controlsList[i].UploadFiles[j].ID, this.controlsList[i].UploadFiles[j].File);
                 // this.controlsList[i].UploadFiles[j].File = null;
                }
              }
              this.controlsList[i].UploadFiles = this.controlsList[i].UploadFiles;
            }
          }
          else if (this.controlsList[i].CONTROL == "10") {
            let SelectedValues = this.controlsList[i].ControlValue;
            if (SelectedValues != null && SelectedValues != undefined && SelectedValues.length > 0) {
              if($.isArray(SelectedValues))
              this.controlsList[i].ControlValue = SelectedValues.join(",");
            }            
            else {
             this.controlsList[i].ControlValue = "";
            }
            this.controlsList[i].SUBFIELDNAME = "";
          }
          else if (this.controlsList[i].CONTROL == "5") {
            let controlanswer = this.controlsList[i].ControlValue;
            if (controlanswer != null && controlanswer != controlanswer != undefined) {
              let formd = this.datepipe.transform(new Date(controlanswer), 'dd-MMM-yyyy');
              this.controlsList[i].ANSWER = formd;
            }
            else {
              this.controlsList[i].ANSWER = controlanswer;
            }
          }     
          
        }    
       uploadData.append("ScreenData", JSON.stringify(this.controlsList));      
        this.summaryService.FilesInsert("api/appuser/InsertGrantsRegistration", uploadData).subscribe((result) => {
          if (result.Status === 0 && result.ErrorCode != "GR01") {
            this.commonService.SuccessBanner(result.Message);
            this.modalRef.close();
          } else if (result.Status === 0 && result.ErrorCode === "GR01") {
            this.commonService.SuccessBanner(result.Message);
            this.modalRef.close();
          }
           else 
           {
            
            for (var i = 0; i < this.controlsList.length; i++) {          
              if (this.controlsList[i].CONTROL == "10") {
                if (this.controlsList[i].ControlValue != null && this.controlsList[i].ControlValue != undefined && this.controlsList[i].ControlValue.length > 0) {
                   this.controlsList[i].ControlValue = this.controlsList[i].ControlValue.split(",");
                }   
              }
            }
              this.commonService.ValidationBanner(result.Message);
            }
        }); 
      }
    }
    else {
      this.commonService.ValidationBanner(errormsg);
    }    
  }

  IsRadioChecked(question: any): void {
    let isError: boolean = false;

    if (question.ControlValue == "" && question.Property.Required) {
      question.Property.TempMessage = question.Property.Message;
      question.Property.ShowMessage = true;
    }
    else {
      question.Property.TempMessage = "";
      question.Property.ShowMessage = false;
    }
  }

  IsCheckBoxChecked(propery: any, question: any): void {
    let isError: boolean = false;
    if (propery != undefined && propery != null) {
      for (var iOpt = 0; iOpt < propery.Options.length; iOpt++) {
        if (propery.Options[iOpt].Checked != null && propery.Options[iOpt].Checked) {
          propery.TempMessage = "";
          propery.ShowMessage = false;
          isError = true;
          break;
        }
      }
    }

    if (!isError) {
      propery.TempMessage = propery.Message;
      propery.ShowMessage = true;
    }
    else {
      propery.TempMessage = "";
      propery.ShowMessage = false;
    }
  }

  public p8(s: boolean): string {
    var p = (Math.random().toString(16) + "000000000").substr(2, 8);
    return s ? "-" + p.substr(0, 4) + "-" + p.substr(4, 4) : p;
  }

  CreateGuid(): string {
    return this.p8(false) + this.p8(true) + this.p8(true) + this.p8(false);
  }

  DeleteUpload(file, ques: REGCONFIG_CONTROL): void {
    this.IsFormToched = true;
    let code = file.ID;
    if (file.Status == "Add") {
      ques.UploadFiles = ques.UploadFiles.filter(function (sec) {
        return sec.ID != code;
      }, code);
    }
    else {
      file.Status = "Delete";
      // this.commonService.CheckIsFileIsRefereancedInReviw(code).subscribe((x)=>{
      //   if(x["Status"]==2 && x["Data"]==false)
      //   {
      //     this.commonService.ValidationBanner(x["Message"]);
      //   }
      //   else{
      //     file.Status = "Delete";
      //   }
      // });
    }
  }

  OpenFile(item: Document_Upload_File): void {
    
      let Url = serviceConstants.apiURL + "api/screen/downloadfile/" + item.ID;
      window.open(Url);
    
  }

  ViewFile(fileID, fileName) {
    this.commonService.previewFile(fileID, fileName, "med");
  }
  uploadchange(event, ques: REGCONFIG_CONTROL): void {
    this.IsFormToched = true;
    let DiffirentFormates = false;
    let samefileName = false;
    let wrongFile = false;
    if (ques.UploadFiles == undefined || ques.UploadFiles == null)
      ques.UploadFiles = [];
    for (let i = 0; i < event.target.files.length; i++) {
      let filename = event.target.files[i].name;
      var ext = filename.match(/\.([^\.]+)$/)[1];
      var filesize = event.target.files[i].size;
      let IsValid = true;
      if (filename != null && ((filesize > 15728640) || (ext != 'docx' && ext != 'doc' && ext != 'ppt' && ext != 'pptx' && ext != 'xls' && ext != 'xlsx' && ext != 'txt' && ext != 'pdf'))) {
        IsValid = false;
        DiffirentFormates = true;
      }
     if (ques.FIELD_CODE=="W9_8_FORMS" && filename != "Form.W-8BEN.pdf" && filename != "Form.W-9.pdf") {
        wrongFile = true;
        IsValid = false;
      }
      if (IsValid) {
        let uploadFile = new Document_Upload_File();
        uploadFile.ID = this.CreateGuid();
        uploadFile.DOCUMENT_NAME = event.target.files[i].name;
        uploadFile.File = event.target.files[i];
        uploadFile.Status = "Add";
        let hasValue = ques.UploadFiles.filter(x => x.DOCUMENT_NAME.toLowerCase() == uploadFile.DOCUMENT_NAME.toLowerCase());
        if (hasValue.length > 0) {
          samefileName = true;
          this.commonService.ValidationBanner("File already exists with " + uploadFile.DOCUMENT_NAME + " Please update the unique file name");

        } else {
          if (ques.ISALLOWMULTIPLEFILES) {
            ques.UploadFiles.push(uploadFile);
          }
          else {
            ques.UploadFiles = [];
            ques.UploadFiles.push(uploadFile);
          }
        }

      }

    }
    if (DiffirentFormates) {
      this.commonService.ValidationBanner("Please upload files with Word, PPT, Excel, Pdf, Text formats only with maximum size of 15MB");

    }
   if (wrongFile) {
      this.commonService.ValidationBanner("Please upload files with same name and format");
    }
  }

  changeVal($event, question) {
    question.NotimesChanged = question.NotimesChanged + 1;
    question.IsTouched = true;
    if (question.NotimesChanged >= 2)
      this.IsFormToched = true;

    setTimeout(() => {
      let selectedControl= question.ControlValue;
      if(selectedControl != "" && selectedControl != undefined && selectedControl != null)
        {
          let controlLabel= question.SourceItems.filter((item)=>{
            return  selectedControl.indexOf(item.value)>-1;
           })
           let labellist=[];
           controlLabel.forEach((item)=>{
             labellist.push(item.label);
           });
           this.tooltipValue =labellist.join(",");
        }
        else
        {
          this.tooltipValue = "";
        }
        
      }, 200);

  }  

  singleonChange($event) {
    this.IsFormToched = true;
  }

  getScreensControlslistEdit()
  {
    this.commonService.getRegistratinConfiguredFiledsData(this.Content.content.id,"GRANTS").subscribe(summary => {
      this.controlsList = summary["Data"];     
      this.IsBlocked=summary["TransactionCode"]=="0"?true:false; 
      if (this.controlsList != null && this.controlsList.length > 0) {
       // this.screenid = this.screencontrols.ID;
        for (var i = 0; i < this.controlsList.length; i++) {
        //  this.controlsList[i].ControlValue = "";
            this.controlsList[i].SourceItems =  [];
          if (this.controlsList[i].CONTROL == "4" || this.controlsList[i].CONTROL == "6" || this.controlsList[i].CONTROL == "7" || this.controlsList[i].CONTROL == "10") {
            // var optionvalues = this.screencontrols.SCREEN_CONTROL[i].GROUP_VALUES;
            var optionvalues = this.controlsList[i].GROUP_VALUES_LIST;
            
            var options = optionvalues;
            this.sourceitems = [];
            // var options = optionvalues.split(',');
            if (options!=null && options!=undefined && options.length > 0) {            
              for (var iOpt = 0; iOpt < options.length; iOpt++) {
                if (options[iOpt] != null && options[iOpt] != "") {
                  let sourceitems = new dropdownsource();
                  sourceitems.label = options[iOpt]["label"];
                  sourceitems.value = options[iOpt]["value"];                  
                  this.sourceitems.push(sourceitems);
                }
              }
              if(this.controlsList[i].CONTROL == "10"){
                let selectedlist=[];
                this.controlsList[i].ControlValue.split(",").forEach((item)=>{
                  selectedlist.push(item);
                });
                this.controlsList[i].ControlValue=selectedlist;
              }

              if (this.controlsList[i].CONTROL == "6") {
                let data =this.controlsList[i].ControlValue != null? this.controlsList[i].ControlValue.split(','): this.controlsList[i].ControlValue;
                if(data != null && data.length > 1){
                  this.controlsList[i].ControlValue.split(",").forEach((item) => {
                    let source = this.sourceitems.find(x=> x.value == item);
                    source.Checked = true;                                    
                  });
                } else{
                  if(this.controlsList[i].ControlValue != null){
                    let source = this.sourceitems.find(x=> x.value == this.controlsList[i].ControlValue);
                    source.Checked = true; 
                  }                    
                }             
              }

              if (this.controlsList[i].CONTROL == "4") {
                let tempList = [];
                let sourceitems1 = new dropdownsource();
                sourceitems1.label = "Select";
                sourceitems1.value = "";
                tempList.push(sourceitems1);
                this.sourceitems = tempList.concat(this.sourceitems);
              }
              this.controlsList[i].SourceItems = this.sourceitems;
            }
          }
          else if (this.controlsList[i].CONTROL == "5") {
             this.controlsList[i].ControlValue= new Date(this.controlsList[i].ControlValue);
             let controlanswer = new Date(this.controlsList[i].ControlValue);
             if (controlanswer != null && controlanswer != controlanswer != undefined &&  this.controlsList[i].DATEFORMATE == 'DD-MMM-YYYY') {
               let formd = this.datepipe.transform(new Date(controlanswer), 'dd-MMM-yyyy');
               this.controlsList[i].ANSWER = formd;
             } 
          }
          else {
            this.controlsList[i].ControlValue =  this.controlsList[i].ControlValue ;
          }
        }          
      }
    });
    
  }

  BlockUser() {
    let formData1 = new Object(); 
    formData1["ID"] = this.Content.content.id;
    formData1["RECORD_STATE"] =  this.IsBlocked== true ? 0 : 1;
    formData1["MODULE"] = this.Content.content.Module;
    this.summaryService.updateUser("api/gm/updateUser", formData1).subscribe((result: any) => {
      if (result.Status == 0) {
        // this.commonService.ErrorBanner("update successful");
        this.commonService.SuccessBanner("Registration Details updated successfully");
        //  this.action.next("Yes");
        this.modalRef.close("Yes");
       
      } else {
        this.commonService.ValidationBanner(result.Message);
      }


    });
  }
}
